import { BrowseCharactersIndexPage } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.characters.index";

export default function BrowseCharactersIndexRoute() {
  return <BrowseCharactersIndexPage />;
}
